import { createAction, props } from '@ngrx/store';
import { DadosContatosOutputDto } from 'src/app/domain/DTOs/output/dados-contatos-output-dto';
import { EstruturaRetornoDadosOutputDto } from 'src/app/domain/DTOs/output/estrutura-retorno-dados.output.dto';

const actionName = "[ ObterDadosContatos ] Obter Contatos";

export const obterDadosContatos = createAction(
  actionName
);

export const obterDadosContatosSuccess = createAction(
  `${actionName} - Sucesso`,
  props<{ response: EstruturaRetornoDadosOutputDto<DadosContatosOutputDto> }>()
);
